<script>
import con from '@services/connection'
import { simulador } from '@constants/URL'
import Title from '@components/section-title'
import Vue from 'vue'
import store from '@state/store'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

export default {
  components: {
    Title,
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      status: {
        // ok: 'Finalizada',
        '200': 'Finalizada',
        '100': 'Simulando...',
        finished: 'Finalizada',
      },
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    clientes() {
      return store.getters['user/allClients']
    },
    simulacoes() {
      const running = store.getters['simulador/getRunning'] || []
      return running.slice().map((s) => {
        const cliente = this.$store.state.user.clientes.find((c) => {
          return c.id === s.id_cliente_app
        })
        if (cliente) {
          return {
            ...s,
            nome_cliente: cliente.name,
          }
        } else {
          return s
        }
      })
    },
  },
  created() {
    GlobalBus.$on(MODAL.SIMULATOR_DETAILS, this.open)
  },
  methods: {
    open() {
      // this.load()
      this.busModal.$emit('dialog', true)
    },
    async load() {
      if (this.loading) {
        return
      }
      this.loading = true
      const r = await con.get(simulador.lista_detalhes)
      if (r.status === 200) {
        this.simulacoes = r.value.reverse()
      } else {
        this.simulacoes = []
      }
      this.loading = false
    },
    openSimulation(s) {
      // Trocar cliente para esse
      const client = store.getters['user/allClients'].find((c) => {
        return (s.id_cliente || s.id_cliente_app) === c.id
      })
      store.dispatch('user/addSearchClient', client)
      GlobalBus.$emit('changeClient')

      this.$router.push({
        name: 'simulador.analise',
        params: {
          hash_code: s.hash_code,
          id_cliente: s.id_cliente || s.id_cliente_app,
          nome_simulacao: s.nome_simulacao,
        },
      })

      this.busModal.$emit('dialog', false)
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal">
    <Title title="Simulações" />

    <div style="height: 55vh;">
      <div
        v-if="loading"
        class="d-flex align-items-center justify-content-center"
        style="height: 100%;"
      >
        <v-progress-circular
          color="primary"
          :size="50"
          indeterminate
        ></v-progress-circular>
      </div>
      <v-list v-if="!loading" height="55vh" style="overflow: auto;">
        <v-list-item-group>
          <v-list-item
            v-for="s in simulacoes"
            :key="s.hash_code"
            @click="openSimulation(s)"
          >
            <v-list-item-content>
              <v-list-item-title>
                <small style="white-space: initial;">
                  {{ s.nome_cliente || 'Cliente' }}
                </small>
              </v-list-item-title>
              <v-list-item-subtitle>
                <div class="d-flex">
                  <small>
                    {{ status[s.status_simulacao] || s.status_simulacao }}
                  </small>
                  <v-spacer />
                  <small> Data: {{ s.data_simulacao }} </small>
                </div>
              </v-list-item-subtitle>
              <v-progress-linear
                v-if="s.status_simulacao === '100'"
                indeterminate
                :stream="true"
                striped
              ></v-progress-linear>
              <hr v-else />
              <!-- v-if="['ok', 'Finalizada', '200'].includes(s.status_simulacao)" -->
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Continuar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


